import Icon from '@ant-design/icons/lib/components/Icon';
import React, { memo, useEffect, useState } from 'react';
import { ListView, SearchBar, Icon as Icons, Toast, ActivityIndicator } from 'antd-mobile';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import HistoryCitiesPart from './components/historyCitiesPart';
import HotCityPart from './components/hotCityPart';
import styles from './index.less';
import * as types from './interfaces';
import { PartOperation } from './interfaces/enums';
import { commonApi } from './sdkLocation';
import { BFD_checkApp } from '@/utils/bfdApp';
import { getCookie, TLang } from '@/utils/lang';
import { getCityPinyin } from '@/utils/other';
import { decreaseLoading, increaseLoading } from '@/public';
import { safeJsonParse } from '@/utils/safeJsonParse';
interface PropTypes {
  /** 历史访问城市数据 */
  historyCities: types.HistoryCities[];
  /** 热门城市数据 */
  hotCity: types.HotCity[];
  /** 所有城市数据 */
  cityList: types.CityModel[];
  /** 当前选中城市 */
  curentCity?: types.CityModel;
  /** 加载态 */
  showLoading: boolean;
  /** 是否启用sdk初始定位,当curentCity为null时候此条件才生效 */
  isSDKInitLocation?: boolean;
  /** sdk配置信息 */
  sdkConfig?: types.MapConfigModel;
  /**
   * 关闭回调事件
   * @param city 选中的城市对象
   * @param id 选择的城市ID
   */
  onClose?: (city?: types.CityModel, id?: number) => void;
}

const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
function genData(ds, cityList) {
  const dataBlob = {}; // 城市ID 和名字的Map
  let sectionIDs = []; // 标志的集合 [ 'A', 'B', 'C']
  let rowIDs = []; // 城市ID的集合 [[], [], []]
  // 处理数据
  const Emptyobj = {};
  const obj = {};
  cityList.forEach((item) => {
    dataBlob[item.cityId] = getCookie('df_lang')==='en-US'?item.pinyin:item.name;
    Emptyobj[item.first] = item.first.toLocaleUpperCase();
    if (obj[item.first]) {
      obj[item.first].push(item.cityId);
    } else {
      obj[item.first] = [];
      obj[item.first].push(item.cityId);
    }
  });
  rowIDs = Object.values(obj);
  sectionIDs = Object.values(Emptyobj);
  // console.log(dataBlob, sectionIDs, rowIDs);
  return ds.cloneWithRowsAndSections(dataBlob, sectionIDs, rowIDs);
}
const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
const getSectionData = (dataBlob, sectionID) => sectionID;

const cityPinyin = localAddress && localAddress?.cityNameValue ? localAddress?.cityNameValue : getCookie('address') && JSON.parse(getCookie('address')).pinyin;
const df_lang = getCookie('df_lang');

// 组件
function SelectCityPart(props: PropTypes) {
  const {
    historyCities,
    hotCity,
    curentCity,
    showLoading,
    cityList,
    isSDKInitLocation,
    sdkConfig,
    onClose
  } = props;

  const [inputValue, setInputValue] = useState('');
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1, row2) => row1 !== row2,
      sectionHeaderHasChanged: (s1, s2) => s1 !== s2
    }),
  );

  useEffect(() => {
    setDataSource(genData(dataSource, cityList));
  }, [cityList]);

  useEffect(() => {
    if (isSDKInitLocation && !curentCity) {
      try {
        commonApi.prefixStr = sdkConfig.apiBasics;
        initAddress();
      } catch (e) {
        console.warn('sdk初始化地址出现出错误,请检查[sdkConfig]配置是否正确');
      }
    }
  }, [isSDKInitLocation, curentCity]);

  const initAddress = (isInitAddress = true, urlCity = '') => {
    try {
      increaseLoading();
      // 获取用户位置
      commonApi.initUserLoaction(isInitAddress, urlCity).finally(() => {
        decreaseLoading();
      }).then(({ code, data }: any) => {
        let obj: types.CityModel = {
          cityId: 145,
          name: '上海',
          cityName: '上海'
        };
        if (code === 200) {
          obj = data;
        }
        changeCity(obj, obj.cityId);
      });
    } catch ({ data }) {
      console.log('地址获取失败,兜底操作!');
      const obj = {
        cityId: data.cityId,
        name: data.name,
        cityName: data.name
      };
      changeCity(obj, obj.cityId);
    }
  };

  const renderHeader = (section) => <div style={{ color: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF' }}>{section}</div>;
  const seeRowData = (rowData, sectionID, rowID) => (
    <div
      key={rowID}
      onClick={() => {
        const item: types.CityModel = {
          cityId: rowID,
          name: rowData,
          cityName: rowData
        };
        changeCity(item, rowID);
      }}
      className={styles.rowItem}
    >
      {rowData}
    </div>
  );

  // 搜索
  const onSearch = (val) => {
    setInputValue(val);
    let arr = [];
    if (val) {
      val = val.toLowerCase();
      arr = cityList.filter(
        (city) => city.pinyin.indexOf(val) !== -1 || city.name.indexOf(val) !== -1,
      );
      setDataSource(genData(dataSource, arr));
    } else {
      arr = [];
      setDataSource(genData(dataSource, cityList));
    }
  };
  // 清空
  const searchClear = () => {
    setInputValue('');
  };
  // 子组件回调
  const partCallBack = (args: types.CallBackModel<types.CityModel>) => {
    switch (args.type) {
    case PartOperation.selectedCity:
      changeCity(args.data, args.data.cityId);
      break;
    }
  };
  // 调用外层回调
  const changeCity = (item: types.CityModel, id: number) => {
    onClose && onClose(item, id);
  };
  // 锚点
  const onQuickSearch = (id) => {
    if (!id) {
      Toast.info(TLang('热门', 'home', false, false, null), 0.5);
      return;
    }
    Toast.info(<div className={styles.toast_SELECT_CITY}>{id}</div>, 0.5, null, false);
  };
  // 关闭按钮回调
  const backBefore = () => {
    // console.log('onClose');
    onClose && onClose();
  };

  // 历史&热门
  const renderHotAndCity = () => (
    <>
      <HistoryCitiesPart historyCities={historyCities} callBack={partCallBack}></HistoryCitiesPart>
      <HotCityPart hotCity={hotCity} callBack={partCallBack}></HotCityPart>
    </>
  );
  // const isApp = BFD_checkApp();
  return (
    <>
      <div className={styles.cityContainer} style={{ height: window.innerHeight }}>
        <div className={styles.search_header}>
          <div className={styles.search_row1}>
            {/* {isApp === false ? (
              <div onClick={backBefore} style={{ display: 'inline-flex', alignItems: 'center' }}>
                <span className={`iconfont ${styles.back}`}>&#xe61b;</span>
              </div>
            ) : null} */}
            <div onClick={backBefore} style={{ display: 'inline-flex', alignItems: 'center' }}>
              <span className={`iconfont ${styles.back}`}>&#xe61b;</span>
            </div>
            <SearchBar
              value={inputValue}
              placeholder={TLang('输入城市或者首字母', 'home', false, false, null)}
              onChange={onSearch}
              onClear={searchClear}
              onCancel={searchClear}
              //@ts-ignore
              cancelText={<span style={{color:window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}}>{TLang('取消', 'home', false, false, null)}</span>}
              showCancelButton={false}
            />
          </div>
          <div className={styles.header_city}>
            <Icon type="pdp_address" />
            {TLang('当前定位城市', 'home', false, false, null)}
            {df_lang && df_lang == 'en-US' ? (
              <span>{getCityPinyin(curentCity?.name) || cityPinyin}</span>
            ) : (
              <span>{curentCity && curentCity.name}</span>
            )}
          </div>
        </div>
        <ListView.IndexedList
          dataSource={dataSource}
          className="am-list sticky-list"
          useBodyScroll={false}
          renderSectionHeader={renderHeader} // 标题
          renderHeader={renderHotAndCity}
          renderRow={seeRowData}
          onQuickSearch={onQuickSearch}
          quickSearchBarStyle={{
            top: '52%',
            transform: 'translateY(-50%)',
            right: '10px'
          }}
          delayTime={100}
          delayActivityIndicator={
            <div style={{ padding: 10, textAlign: 'center' }}>
              <Icons type="loading" />
            </div>
          }
          quickSearchBarTop={{ value: '#', label: TLang('热', 'home', false, false, null) }}
        />
        <div className="toast-example">
          <ActivityIndicator toast text={TLang('加载中', 'home', false, false, null)+'...'} animating={showLoading} />
        </div>
      </div>
    </>
  );
}
export default memo(SelectCityPart);
